import { render, staticRenderFns } from "./box-8-unit-1.vue?vue&type=template&id=312c8fc4&scoped=true&"
import script from "./box-8-unit-1.vue?vue&type=script&lang=ts&"
export * from "./box-8-unit-1.vue?vue&type=script&lang=ts&"
import style0 from "./box-8-unit-1.vue?vue&type=style&index=0&id=312c8fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312c8fc4",
  null
  
)

export default component.exports